import DashboardAdminRecommendedUtilityFormModal from '../components/DashboardAdminRecommendedUtilityFormModal';
import { schema } from '../../../../../state/schema';
import { List } from 'immutable';
import {
  recommendedUtilityAdminFormDestroy,
  recommendedUtilityAdminHideForm,
  loadRecommendedUtilitiesAdmin,
  recommendedUtilityAdminShowForm,
  createRecommendedUtilityAdmin,
  updateRecommendedUtilityAdmin,
  recommendedUtilityAdminRemoveFile,
  uploadFile,
  getRecommendedUtilityAdminUploadURL,
} from '../../../../../state/modules/recommendedUtilitiesAdmin/actions';
import { denormalize } from 'normalizr';
import { connect } from 'react-redux';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List(['title', 'doc-file', 'website']);

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const errors = {};
  for (const val of inputs.values()) {
    if (state.recommendedUtilitiesAdmin.getIn(['form', 'errors', val])) {
      errors[val] = state.recommendedUtilitiesAdmin.getIn([
        'form',
        'errors',
        val,
      ]);
    }
  }

  const recommendedUtilityId = state.recommendedUtilitiesAdmin.get('id');

  const recommendedUtility = recommendedUtilityId
    ? denormalize(
        state.entities.getIn([
          'recommendedUtilitiesAdmin',
          recommendedUtilityId,
        ]),
        schema.recommendedUtility,
        state.entities.toJS()
      )
    : null;

  const data = {
    title: recommendedUtility ? recommendedUtility.title : '',
    file_name_bucket: recommendedUtility
      ? recommendedUtility.file_name_bucket
      : '',
    file_name: recommendedUtility ? recommendedUtility.file_name : '',
    file_directory: recommendedUtility ? recommendedUtility.file_directory : '',
    file_bucket: recommendedUtility ? recommendedUtility.file_bucket : '',
    file_extension: recommendedUtility ? recommendedUtility.file_extension : '',
    size_bytes: recommendedUtility ? recommendedUtility.size_bytes : '',
    website: recommendedUtility ? recommendedUtility.website : '',
  };

  return {
    visible: state.recommendedUtilitiesAdmin.get('isFormVisible'),
    isSubmitting:
      state.recommendedUtilitiesAdmin.getIn(['form', 'isSubmitting']) ||
      state.recommendedUtilitiesAdmin.get('isDocumentUploading') ||
      state.recommendedUtilitiesAdmin.get('isRemoveFile') ||
      state.recommendedUtilitiesAdmin.get(
        'isRecommendedUtilityUploadUrlLoading'
      ),
    success: state.recommendedUtilitiesAdmin.getIn(['form', 'success']),
    recommendedUtilityId: recommendedUtilityId,
    recommendedUtility: recommendedUtility,
    data: data,
    errors: errors,
    partnershipId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formDestroy: (formState) => {
      dispatch(recommendedUtilityAdminFormDestroy(formState));
    },
    hideForm: () => {
      dispatch(recommendedUtilityAdminHideForm());
    },
    create: (partnershipId, data, cb) => {
      dispatch(createRecommendedUtilityAdmin(partnershipId, data, cb));
    },
    update: (partnershipId, id, data, cb) => {
      dispatch(updateRecommendedUtilityAdmin(partnershipId, id, data, cb));
    },
    load: (partnershipId, page, limit, order, cb) => {
      dispatch(
        loadRecommendedUtilitiesAdmin(partnershipId, page, limit, order, cb)
      );
    },
    getUploadUrl: (extension, directory, cb) => {
      dispatch(getRecommendedUtilityAdminUploadURL(extension, directory, cb));
    },
    upload: (path, file, cb) => {
      dispatch(uploadFile(path, file, cb));
    },
    destroy: (path, cb) => {
      dispatch(recommendedUtilityAdminRemoveFile(path, cb));
    },
    showForm: (recommendedUtilityId) => {
      dispatch(recommendedUtilityAdminShowForm(recommendedUtilityId));
    },
  };
};

const DashboardAdminRecommendedUtilityFormModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardAdminRecommendedUtilityFormModal);

export default DashboardAdminRecommendedUtilityFormModalContainer;
